import React from 'react';

export interface AudioContentProps {
  src: string;
  className?: string;
  onClick?: () => void;
}

export interface AudioContentValue {
  url: string;
}

export const AudioContent: React.FunctionComponent<AudioContentProps> = props => {
  const className = `w-100 mx-auto my-2 ${props.className || ''}`;

  return (
    <audio className={className} controls>
      <source src={props.src} />
      Your browser does not support the video tag.
    </audio>
  );
};
